<template>
  <div  class="container">
    <!-- 内容 -->    
    <div class="theme">
      <div class="title">{{albumName != '' ? albumName : categoryName}}</div>

      <div v-for="(posts ,index) in postsList" :key="index" @click="select(posts.postsId)">
        <div class="item">
          <div class="item-title">{{posts.postsTitle}}</div>
          <div class="item-time">{{posts.postsTime.substring(0,10)}}</div>
        </div>
      </div>
      
      <!-- <div class="status"> 
        <div v-if="pageMessage.hasNextPage == true && canLoad == false" style="height:20px;text-align: center;font-weight:350;font-size:40px;color:#8b8b8b">
          <i class="el-icon-loading"></i>
        </div>
        <div v-if="pageMessage.hasNextPage == true && canLoad == true" style="height:20px;text-align: center;font-weight:350;font-size:14px;color:#0058a4;margin-top:0px;cursor: pointer;" @click="getMorePosts()">
          加载更多
        </div>
        <div v-if="pageMessage.hasNextPage == false" style="height:20px;text-align: center;font-weight:350;font-size:14px;color:#8b8b8b;margin-top:0px;">
          已加载完全部
        </div>
      </div> -->
      <div style="padding:20px 0px 20px 0px" v-if="pageMessage.pages > 1">
        <el-pagination
          :total="pageMessage.total"
          :page-size="15"
          @current-change="handCurrentChange" 
          :current-page="pageMessage.pageNum" 
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>

    </div>
    
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Theme",
  data() {
    return {
      pageNum:1,
      
      searchContent:"",
      categoryName:"",
      albumName:"",

      postsList:[],
      pageMessage:[],
      canLoad:true,
    };
  },
  mounted(){
    this.categoryName = this.$route.query.categoryName
    this.albumName = this.$route.query.albumName
    this.getPostsList()
  },
  methods: {
    getPostsList(){
      this.loading = true
      let formData = new FormData();
      formData.append("pageNum", this.pageNum);
      formData.append("categoryName", this.categoryName);
      formData.append("albumName", this.albumName);
      formData.append("searchContent", this.searchContent);
      var url = this.GLOBAL.URL+"/postsList"
      axios.post(url,formData).then((response) => {
        console.log(response.data);
        this.postsList = response.data.list
        this.pageMessage = response.data
        this.loading = false
      });
    },
    handCurrentChange(current){
      this.pageNum = current
      this.getPostsList()
    },
    select(postsId){
      this.$router.push({
        path: '/detail',
        query: { 
          postsId: postsId,
        }
      })
    }
  },
  watch: {
    '$route' (to, from) {
      if(to.path == '/theme'){
        if(to.query.categoryName != this.categoryName || to.query.albumName != this.albumName){
          window.scrollTo(0, 0)
          this.pageNum = 1
          this.categoryName = this.$route.query.categoryName;
          this.albumName = this.$route.query.albumName;
          this.postsList = []
          this.pageMessage = []
          this.getPostsList()
        }
      }
    }
  },
};
</script>

<style scoped>
.container {
  min-width: 1300px;
  max-width:1920px;
  margin:0px auto;
}
.title{
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 20px;
}
.theme{
  padding: 40px 190px 0px 190px;
}
.item{
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  padding: 10px;
  color: #747474;
  border-bottom: 1px dashed #dadada;
}
.item-title{
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 20px;
}
.item-time{
  white-space: nowrap;
}
.item:hover{
  /* background-color: #efefef; */
  color: #0058a4;
  /* border-radius: 10px; */
}
.status{
  margin: 15px;
  height:50px;
  text-align: center;
  display:flex;
  align-items: center;
  justify-content: center;
  font-weight:350;
  color:#8b8b8b;
}
</style>